const { certificateEventRoutes } = require("../../constants/Routes");
const axios = require("axios");
const { getItem } = require("../../backend/StorageUtils");
export const handleShareAnon = async (
	sharingFor,
	credential_no,
	organization_id,
	linkedinSharePostLink = null
) => {
	let userId = getItem("__uid__") || 0;
	await axios.post(certificateEventRoutes.certificatesShareEventAnon, {
		credential_no,
		sharingFor,
		organization_id,
		user_id: userId,
		linkedinSharePostLink,
	});
};

export const logActionEvent = async (
	cred_no,
	action,
	organization_id,
	recipient_group_id
) => {
	try {
		let userId = getItem("__uid__") || 0;
		await axios.post(certificateEventRoutes.logActionEvent, {
			user_id: userId,
			platform: 1,
			value: cred_no,
			string_value: null,
			type: action,
			organization_id,
			recipient_group_id,
		});
	} catch (err) {
		console.log(err);
	}
};
